import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { IMapCoreMap, IMapQueryConfiguration, IMergeMapData, IMergeMapDataLayer } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-merge-map',
    templateUrl: './merge-map.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './merge-map.component.scss']
})
export class MergeMapComponent extends BaseComponent {
    private _map: IMapCoreMap;
    @Input() set map(value: IMapCoreMap) {
        if (value) {
            this._map = value;
            this.getMapLayers();
        }
    }
    get map(): IMapCoreMap {

        return this._map;
    }
    @Input() includeMapFilter = false;
    @Output() readonly ondone: EventEmitter<any> = new EventEmitter<any>();
    @Output() readonly oncancel: EventEmitter<any> = new EventEmitter<any>();

    mapLayers: IMergeMapDataLayer[] = [];
    isAllLayersSelected = false;
    loading = false;

    constructor(_vcr: ViewContainerRef,
                private readonly layerService: LayerService,
                private readonly mapService: MapService,
                private readonly cdr: ChangeDetectorRef) {
        super(_vcr, true);
        this.registerEvent('ondone', this.ondone);
        this.registerEvent('oncancel', this.oncancel);
    }

    async getMapLayers() {
        this.loading = true;
        const mapData: IMergeMapData = JSON.parse(this.map.data);
        this.cdr.detectChanges();
        let yearConfig: IMapQueryConfiguration[] = [];
        if (mapData && mapData.paramConfig) {
            yearConfig = mapData.paramConfig.filter(x => x.type === 'CYFY');
        }
        const layers = await this.layerService.getLayers(this.getLayerIds(mapData.layers));
        for (const layer of layers) {
            if (yearConfig && yearConfig.length > 0) {
                this.layerService.updateLayerName(yearConfig[0], layer.mapcoreProps);
            }
            const mapLayer: IMergeMapDataLayer = {
                name: layer.mapcoreProps.name,
                id: layer.mapcoreProps.id,
                description: layer.mapcoreProps.description,
                isChecked: false
            };
            this.mapLayers.push(mapLayer);
        }
        this.loading = false;
        this.cdr.detectChanges();
    }

    getLayerIds(layers) {
        return layers.flatMap((layer) => {
           if (layer.id) {
               return layer.id;
           } else {
               return this.getLayerIds(layer.layers);
           }
       });
   }

    toggleLayers() {
        this.mapLayers.forEach(lyr => lyr.isChecked = !this.isAllLayersSelected);
    }

    checkAllSelected(lyr) {
        if (!lyr.isChecked) {
            this.isAllLayersSelected = false;
        } else {
            const checkedLayers = this.mapLayers.filter((l) => l.isChecked);
            this.isAllLayersSelected = checkedLayers.length === this.mapLayers.length;
        }
    }

    async addToMap() {
        this.mapService.mapStatus.next('loading');
        const layers = this.mapLayers.filter((lyr) => lyr.isChecked);
        await this.layerService.addMapcoreLayersToMap(layers);
        this.mapService.mapStatus.next('loaded');
        this.clearData();
        this.ondone.emit(this.includeMapFilter);
    }

    cancel() {
        this.clearData();
        this.oncancel.emit();
    }

    clearData() {
        this.map = null;
        this.mapLayers = [];
        this.isAllLayersSelected = false;
    }

}
